export const environment = {
  production: false,
  ssoUrl: 'https://sso-int.greenpowermonitor.com/auth',
  apiserver: 'https://image-server-int.energy-log.com'
};